<template>
  <bsp-dialog :title="$t('cost.cost084')" :dialogVisible.sync="visible" @closeButton="closeDialog" width="900px"><!-- 分摊信息维护 -->
    <template #body v-loading="loading">
      <div class="gridHead">
        <el-form ref="mainForm" :model="mainForm" :rules="rules" style="padding: 0; margin-top: 0; width: 100%;" label-width="100px" @submit.native.prevent>
          <el-row>
            <el-col :span="8">
              <el-form-item :label="$t('cost.cost085')"><!-- 分摊类型 -->
                <bsp-dicts-select v-model="mainForm.type" :select-value.sync="mainForm.type" :options-list="typeList" @selectChange="typeChange" :disabled="optParams.editFlag == 'view'"></bsp-dicts-select>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <span style="color: red; padding-left: 10px" v-show="mainForm.type == 'item'">{{$t('cost.cost086')}}</span><!-- 提示：如同时选择了【项目组】和【分摊信息】，将以【分摊信息】填写的项目为准。 -->
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item :label="mainForm.typeName" class="form-item-content-auto">
                <el-checkbox-group v-model="orgArray" ref="orgCheckbox" @change="orgChange" :disabled="optParams.editFlag == 'view'">
                  <el-checkbox :label="typeDetail.ITEM_ID" v-for="typeDetail in typeDetailList" :key="typeDetail.ITEM_ID">{{typeDetail.ITEM_NAME}}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item :label="$t('cost.cost087')"><!-- 方式 -->
                <bsp-dicts-select v-model="mainForm.way" :select-value.sync="mainForm.way" :options-list="wayList" :disabled="optParams.editFlag == 'view'"></bsp-dicts-select>
              </el-form-item>
            </el-col>
            <el-col :span="16">
            </el-col>
          </el-row>
          <bsp-collapsible-module :title="$t('cost.cost088')"><!-- 分摊信息 -->
            <el-row v-for="(orgBO,index) in orgList" :key="index">
              <el-col :span="8">
                <el-form-item :label="mainForm.typeName" label-width="50px">
                  <div>{{ orgBO.orgName }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('cost.cost089')" v-show="mainForm.way == '80110002'"><!-- 比例 -->
                  <div class="form-item-flex">
                    <el-input-number v-model="orgBO.scale" :controls="false" precision="0" min="-0.1" max="100.1" @change="scaleChange(orgBO)" :disabled="optParams.editFlag == 'view'"></el-input-number>
                    <span>%</span>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('cost.invoice038')"><!-- 含税金额 -->
                  <el-input-number v-model="orgBO.money" :controls="false" precision="2" min="-0.1" max="999999999.1" :disabled="optParams.editFlag == 'view'"></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
          </bsp-collapsible-module>
        </el-form>
      </div>
      <!-- 没有实质的用处，解决页面不刷新-->
      <div v-show="false">
        <div v-for="ff in fileListRefresh" :key="ff">{{ff}}</div>
      </div>

    </template>
    <div class="dialog-footer" slot="footer" v-show="optParams.editFlag != 'view'">
      <el-button type="default" v-show="optParams.shareId == null || optParams.shareId == ''" @click="closeDialog">{{$t('homepage.txt019')}}</el-button><!-- 取消 -->
      <div>
        <el-button type="default" v-show="optParams.shareId != null && optParams.shareId != ''" @click="deleteShare">{{$t('cost.cost090')}}</el-button><!-- 取消分摊 -->
        <el-button type="primary" @click="submitForm()">{{$t('homepage.txt018')}}</el-button><!-- 确定 -->
      </div>
    </div>
  </bsp-dialog>
</template>

<script>
import BspDialog from "@/components/bsp/bsp-dialog/bsp-dialog";
import BspDictsSelect from '@/components/bsp/bsp-dicts-select/bsp-dicts-select'
import { getUserCusList, getUserCusListZz, getAllCusList} from "@/api/sys/cus";
import {mapGetters} from 'vuex';
import BspCollapsibleModule from '@/components/bsp/bsp-collapsible-module/bsp-collapsible-module'
import {getDictsListBySetId} from '@/api/sys/code'
import { getNowFormatDate} from "@/util/date_format.js"
import {getCloudAvailableShareType, getCloudShareProjectList, getCloudShareDeptList, saveCloudShareInfo, getCloudShareInfoByShareId, delCloudShareInfo} from "@/api/cost/cost";
import { uploadFile, downloadQiniuFile } from "@/api/sys/sys";
import { downloadFile } from '@/util/util'
export default {
  name: "invoiceFolderEdit",
  components: {BspDictsSelect, BspDialog, BspCollapsibleModule},
  props:{
    optParams: {
      type: Object,
      default: function (){
        return {
        };
      },
    },
  },
  data() {
    return {
      mainForm:{
        type: 'org',
        typeName : '部门',
        org: "",
        way: "80110002",
      },
      optType: 'add', //页面操作类型
      from : "",

      searchParams: {},
      demoLoading: false,
      visible: false,
      typeList: [
        {codeItemId : 'org', codeItemName : '部门'},
        {codeItemId : 'item', codeItemName : '项目'},
      ],
      wayList: [
        {codeItemId : '80110001', codeItemName : '金额'},
        {codeItemId : '80110002', codeItemName : '比例'},
      ],
      typeDetailList: [],
      orgArray: [],
      orgList: [],
      orgIdList:[],
      deptList:[],
      projectList: [],
      shareDataList: [],
      activeMap:{},
      deptMap: {},
      projectMap: {},

      rules: {
      },
    };
  },
  created() {
    //this.init();
  },
  mounted(){
    // console.log("批次号m",this.billBatch)
  },
  methods: {
    //初始化仓库
    init() {
      this.getCloudAvailableShareType();

    },
    getCloudAvailableShareType() {
      let params = {
        searchParams : {
          projectId: this.optParams.projectId,
          applierId: this.optParams.applierId,
        }
      }

      getCloudAvailableShareType(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          if(result.code == '0'){
            if(result.data.availableShareType == "projectOnly"){
              this.$set(this.mainForm, "type", "item");
              this.$set(this, "typeList", [{codeItemId : 'item', codeItemName : '项目'}]);
              this.typeChange("item");
            }else{

              this.$set(this, "deptList", result.data.shareDept);

              for(var i = 0 ; i < this.deptList.length; i++){
                this.$set(this.deptMap, this.deptList[i].ITEM_ID, this.deptList[i].ITEM_NAME);
              }
            }

            this.$set(this, "projectList", result.data.shareProject);

            for(var i = 0 ; i < this.projectList.length; i++){
              this.$set(this.projectMap, this.projectList[i].ITEM_ID, this.projectList[i].ITEM_NAME);
            }

            if(!this.optParams.shareId){
              if(this.mainForm.type == "org"){
                this.$set(this, "typeDetailList", this.deptList);
                this.$set(this, "activeMap", this.deptMap);
              }else if(this.mainForm.type == "item"){
                this.$set(this, "typeDetailList", this.projectList);
                this.$set(this, "activeMap", this.projectMap);
              }
            }else{
              this.getCloudShareInfoByShareId();
            }


          }else{
            this.$message.success(result.msg);
          }
        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });
    },
    getCloudShareProjectList() {
      let params = {
        searchParams : {
        }
      }

      getCloudShareProjectList(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          if(result.code == '0'){
            this.$set(this, "projectList", result.data);

            for(var i = 0 ; i < this.projectList.length; i++){
              this.$set(this.projectMap, this.projectList[i].ITEM_ID, this.projectList[i].ITEM_NAME);
            }

            if(this.mainForm.type == "item"){
              this.$set(this, "typeDetailList", this.projectList);
              this.$set(this, "activeMap", this.projectMap);
            }

          }else{
            this.$message.success(result.msg);
          }
        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });
    },
    getCloudShareDeptList() {
      let params = {
        searchParams : {
        }
      }

      getCloudShareDeptList(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          if(result.code == '0'){
            this.$set(this, "deptList", result.data);

            for(var i = 0 ; i < this.deptList.length; i++){
              this.$set(this.deptMap, this.deptList[i].ITEM_ID, this.deptList[i].ITEM_NAME);
            }

            if(this.mainForm.type == "org"){
              this.$set(this, "typeDetailList", this.deptList);
              this.$set(this, "activeMap", this.deptMap);
            }
          }else{
            this.$message.success(result.msg);
          }
        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });
    },
    getCloudShareInfoByShareId() {
      let params = {
        searchParams : {
          shareId: this.optParams.shareId
        }
      }

      getCloudShareInfoByShareId(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          if(result.code == '0'){
            console.log("getCloudShareInfoByShareId", result.data);

            this.$set(this.mainForm, "type", result.data.type);

            if(this.mainForm.type == "org"){
              this.$set(this, "typeDetailList", this.deptList);
              this.$set(this, "activeMap", this.deptMap);
            }else if(this.mainForm.type == "item"){
              this.$set(this, "typeDetailList", this.projectList);
              this.$set(this, "activeMap", this.projectMap);
            }

            var queryOrglist = result.data.org.split(",");
            for(var i = 0; i < queryOrglist.length; i++){
              if(queryOrglist[i]){
                this.orgIdList.push(queryOrglist[i]);
                this.orgArray.push(queryOrglist[i]);
              }
            }

            this.$set(this.mainForm, "way", result.data.way);

            var detail = result.data.detail;

            for(var i = 0; i < detail.length; i++){
              var orgName = this.activeMap[detail[i].org];
              var orgBO = {
                typeValue : detail[i].org,
                org : detail[i].org,
                orgName : orgName,
                scale : detail[i].scale,
                money : detail[i].money,
              };
              this.orgList.push(orgBO);
            }

          }else{
            this.$message.success(result.msg);
          }
        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });
    },

    typeChange(val){
      if(val == "item"){
        this.$set(this, "typeDetailList", this.projectList);
        this.$set(this, "activeMap", this.projectMap);
        this.$set(this.mainForm, "typeName", "项目");
        this.clearListOrgList();
      }else {
        this.$set(this, "typeDetailList", this.deptList);
        this.$set(this, "activeMap", this.deptMap);
        this.$set(this.mainForm, "typeName", "部门");
        this.clearListOrgList();
      }
    },
    orgChange(selectArray){
      console.log("orgChange", selectArray);

      if(selectArray.length > 0){

        for(var i = 0; i < selectArray.length; i++){
          if(this.orgIdList.indexOf(selectArray[i]) < 0){
            //当前选项在列表中没有直接添加
            this.orgIdList.push(selectArray[i]);
            var orgName = this.activeMap[selectArray[i]];
            var rate = 0;
            var money = 0;

            if(selectArray.length == 1){
              rate = 100;
              money = this.optParams.amount;
            }

            var orgBO = {
              typeValue : selectArray[i],
              org : selectArray[i],
              orgName : orgName,
              scale : rate,
              money : money,
            };
            this.orgList.push(orgBO);

          }
        }

        //删除取消的
        for(var i = 0; i < this.orgIdList.length; i++){
          if(selectArray.indexOf(this.orgIdList[i]) == -1 ){
            this.orgIdList.splice(i, 1);
            this.orgList.splice(i, 1);
            break;
          }
        }
      }else{
        //清空
        this.$set(this, "orgList", []);
        this.$set(this, "orgIdList", []);
      }

    },
    scaleChange(orgBO){
      this.$set(orgBO, "money", (orgBO.scale * this.optParams.amount / 100).toFixed(2));
    },
    deleteShare(){
      let params = {
        searchParams : {
          shareId: this.optParams.shareId
        }
      }

      delCloudShareInfo(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          if(result.code == '0'){
            this.$message.success(this.$t('homepage.txt028')); //操作成功
            this.$emit('reload', 'del');
            this.clearForm();
            this.visible = false;

          }else{
            this.$message.success(result.msg);
          }
        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });
    },
    submitForm () {

      if(this.orgList.length == 0){
        this.$message.error(this.$t('cost.cost091')); //请先设置分摊信息在进行保存！
        return false;
      }

      var total  = 0;//分摊总金额
      for(var i = 0; i < this.orgList.length; i++){
        if(this.orgList[i].money == 0){
          this.$message.error(this.$t('cost.cost092')); //分摊金额不能为0,请重新输入！
          return false;
        }
        total += this.orgList[i].money;
      }


      if(total.toFixed(2) != parseFloat(this.optParams.amount).toFixed(2)){
        this.$message.error(this.$t('cost.cost093') + this.optParams.amount ); //分摊总金额应为
        return false;
      }

      var org = ""
      for(var i = 0; i < this.orgArray.length; i++){
        org += this.orgArray[i] + ",";
      }

      var params = {
        mainForm: {
            shareId : this.optParams.shareId,
            costId : this.optParams.costId,
            type : this.mainForm.type,
            way : this.mainForm.way,
            org : org,
            detail : this.orgList,
          }
      };

      this.demoLoading = true;
      const that = this;
      saveCloudShareInfo(params)
        .then(res => {
          that.demoLoading = false;
          //console.log(res);
          var code = res.data.code;
          if(code == "0"){
            that.$message.success(that.$t('homepage.txt028')); //操作成功
            that.$emit('reload', res.data.data);
            that.clearForm();
            that.visible = false;
          }else{
            that.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          that.demoLoading = false;
          if(error.data.msg){
            that.$message.error(error.data.msg);
          }else{
            that.$message.error(error);
          }
        })
    },


    closeDialog () {
      this.clearForm();
      this.visible = false;

    },
    clearForm(){
      this.$set(this, "mainForm", {
        type: 'org',
          typeName : '部门',
          org: "",
          way: "80110002",
      },);
      this.clearListOrgList();
    },
    clearListOrgList(){
      this.$set(this, "orgArray", []);
      this.$set(this, "orgList", []);
      this.$set(this, "orgIdList", []);
    },
    doGoBack(){
      if(this.from == "platform"){
        this.$router.push({path:'/index'});
      }else if(this.from == "glCusList"){
        this.$router.push({path:'/taskDispatch/glCusList'});
      } else if (this.from == 'backendList') {
        this.$router.go(-1)
      } else{
        var param = {
          beCreateFlag : this.$route.query.beCreateFlag,
          pagerConfig : this.$route.query.pagerConfig,
          searchForm : this.$route.query.searchForm
        }
        //console.log("goback");
        //console.log(param);
        this.$router.push({path:'/taskDispatch/taskList', query: param});
      }
    },

    isNotBlank(str){
      if(str == null || str ==undefined || str == ''){
        return false;
      }else{
        return true;
      }
    }
  },
  destroyed(){
  },
  computed: {
    ...mapGetters(['billBatch','userInfo','dicts']),

  }
};
</script>

<style lang="scss">
</style>
